import ProjectSession from "../../../../core/model2/project/project-session";
import SettingsSearch from "../../../../layout/search/sections/settings/settings-search";
import CompanyUser from "../../../../core/model2/company-user-new/company-user";
import SettingsModule from "../../../../core/modules/settings-module";
import QuickSearch_ResultProject from "../components/search-results/items/project";
import QuickSearch_ResultUser from "../components/search-results/items/user";
import QuickSearch_ResultModule from "../components/search-results/items/module";
import QuickSearch_ResultTask from "../components/search-results/items/task";
import QuickSearch_ResultDocument from "../components/search-results/items/document";


// const debug = "QuickSearchResults"
const debug = false


export type QuickSearchResult = {
    item        : any // project user module... whatever
    index       : number
    component   : any
    onClick     : callback
}



export class QuickSearchResults {


    public items: QuickSearchResult[] = [];

    public projects     : ProjectSession[]  = []
    public views        : any[]     = []
    public users        : CompanyUser[]     = []
    public tasks        : any[]     = []
    public documents    : any[]     = []
    public modules      : SettingsModule[]   = []

    constructor() {

    }

    combineResults() {

        this.items  = []
        let index= 0

        const closeAll = () => {
            gd.modal.hide()
            gd.layout.popovers.closeAll()
        }


        _.map(this.projects, (project)=>{
            this.items.push({
                item        : project,
                component   : QuickSearch_ResultProject,
                index       : index++,
                onClick     : ()=>{
                    closeAll()
                    gd.navigation.goToProject(project.id)
                }
            })
        })

        _.map(this.users, (companyUser)=>{
            this.items.push({
                item        : companyUser,
                index       : index++,
                component   : QuickSearch_ResultUser,
                onClick     : ()=>{
                    closeAll()
                    gd.navigation.goToCompanyUser(companyUser.id)
                }
            })
        })

        _.map(this.modules, (module:SettingsModule)=>{
            this.items.push({
                item        : module,
                component   : QuickSearch_ResultModule,
                index       : index++,
                onClick     : ()=>{
                    closeAll()
                    module.goToSettings()
                }
            })
        })

        _.map(this.tasks, (task:any)=>{
            this.items.push({
                item        : task,
                component   : QuickSearch_ResultTask,
                index       : index++,
                onClick     : ()=>{
                    closeAll()
                    gd.navigation.goToTask(task.id)
                }
            })
        })

        _.map(this.documents, (document:any)=>{
            this.items.push({
                item        : document,
                component   : QuickSearch_ResultDocument,
                index       : index++,
                onClick     : ()=>{
                    closeAll()
                    gd.navigation.goToDocument(document.id)
                }
            })
        })



    }

    get noResults():boolean {
        return _.size(this.items) < 1
    }


    clearData = () => {

        this.items      = []

        this.projects   = []
        this.views      = []
        this.users      = []
        this.tasks      = []
        this.documents  = []
        this.modules    = []
    }

    searchProjects(query:string):void {

        _.map(gd.session.projects.models, (project: ProjectSession) => {

            if (project.searchMatch(query)) { // || project.id === value)
                this.projects.push(project)
            }
        })

        this.projects   = _.orderBy(this.projects, (p:ProjectSession)=>{return p.name.toLowerCase()})

    }

    searchUsers(query:string):void {
        gd.session.companyUsers.map((cu: CompanyUser)=>{
            if (cu.user.name.toLowerCase().includes(query)) {
                this.users.push(cu)
            }
        })

        this.users      = _.orderBy(this.users, cu=>cu.user.name.toLowerCase())
    }

    searchModules(query:string):void {
        this.modules = new SettingsSearch(true, false, false).search(query)
    }



}